import moment from "moment";
import Utils from "../../utils";
import { ItemComplete, SupportDocument, SupportDocumentFormSchema } from "../../schemas/SupportDocument";

const electronicBillMapper = {
  formToSchema: (form: SupportDocumentFormSchema, items: ItemComplete[]): SupportDocument => {
    let tax = {
      code: '5',
      description: 'Reteiva',
      percent: 0,
      taxAmount: 0,
      taxableAmount: form.totalToPay
    }
    return {
      date: form.date,
      orderReference: form.orderReference,
      third: form.third ?? {
        document: '',
        dv: undefined,
        documentType: {
          code: '',
          description: ''
        },
        organizationType: {
          code: '',
          description: ''
        },
        liabilityType: {
          code: '',
          description: ''
        },
        regimeType: {
          code: '',
          description: ''
        },
        name: undefined,
        lastname: undefined,
        businessName: undefined,
        phone: '',
        address: '',
        email: ''
      },
      postalZoneCode: form.postalZoneCode,
      wayToPay: form.wayToPay,
      paymentMethod: form.paymentMethod,
      paymentDueDate: moment(form.paymentDueDate).format('YYYY/MM/DD'),
      note: form.note,
      items: items,
      holdingTaxes: [tax],
      taxes: Utils.buildTaxesForElectronicBill(items),
      total: form.total,
      totalHoldingTaxes: form.totalHoldingTaxes,
      totalToPay: form.totalToPay,
    }
  },

  schemaToForm: (bill: any): { form: SupportDocumentFormSchema, items: ItemComplete[], holdingTaxes: any[] } => {
    return {
      form: {
        number: Number(bill.number),
        date: moment(bill.date).format('YYYY-MM-DD'),
        preview: bill.preview,
        orderReference: bill.orderReference,
        third: bill.third,
        postalZoneCode: bill.postalZoneCode,
        wayToPay: { code: bill.wayToPay.code, description: bill.wayToPay.description },
        paymentMethod: { code: bill.paymentMethod.code, description: bill.paymentMethod.description },
        paymentDueDate: moment(bill.paymentDueDate).format('YYYY-MM-DD'),
        note: bill.note,
        total: bill.total,
        totalHoldingTaxes: bill.totalHoldingTaxes,
        totalToPay: bill.totalToPay,
        currentItemType: {
          code: '',
          description: ''
        },
        currentPrice: 0,
        currentQuantity: 0,
        selectedHoldingTax: {
          code: '',
          description: ''
        },
        currentPercentHoldingTax: 0,
        currentDetailedDescription: ''
      },
      items: bill.items,
      holdingTaxes: Utils.buildTaxesForElectronicBill(bill.items)
    }
  }
}

export default electronicBillMapper
